import { Payment, initMercadoPago } from '@mercadopago/sdk-react';
import { useEffect } from 'react';
import { alertModal } from '../utils/modalController';

initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY || '');

const apiUrl = process.env.REACT_APP_API_URL || '';

interface Props {
    paymentId: string; // ID do pagamento, opcional se for usado apenas para criar a preferência
    preferenceId?: string;
    paymentMethods: {
        ticket: "all" | string[],
        bankTransfer: "all" | string[],
        creditCard: "all" | string[],
        prepaidCard: "all" | string[],
        debitCard: "all" | string[],
        mercadoPago: "all" | string[],
    };
    amount: number;
    onSubmit: (paymentId: string, status: string) => void;
    onUpdateValues?: (numParcelas: number | null, valorParcela: number | null, valorTotal: number | null, acrescimo: number) => void;
}

export default function PaymentBrick({ paymentId, preferenceId, paymentMethods, amount, onSubmit, onUpdateValues }: Props) {
    function extrairValores(parcelaTexto: string) {
        const regex = /(\d+)x\sR\$\s([\d,]+)\s\((R\$\s[\d,]+)\)/;
        const match = parcelaTexto.match(regex);


        if (match) {
            const numeroParcelas = parseFloat(match[1]);
            const valorParcela = parseFloat(match[2].replace(',', '.'));
            const valorTotal = parseFloat(match[3].replace(',', '.').replace('R$ ', ''));

            return {
                numeroParcelas,
                valorParcela,
                valorTotal,
            };
        }

        return null;
    }

    const initialization = {
        amount,
        preferenceId,
    };

    const customization = {
        visual: {
            hideFormTitle: true,
            style: {
                theme: "bootstrap" as const,
            },
        },
        paymentMethods,
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const container = Array.from(document.querySelectorAll('h2'))
                .find(h2 => h2.textContent?.includes('Selecione o número de parcelas'))
                ?.parentElement;

            const select = container?.querySelector('select');

            if (!select || amount == null) {
                onUpdateValues?.(1, amount, amount, 0);
                return;
            }

            const selectedOption = select.options[select.selectedIndex];
            const valores = extrairValores(selectedOption.textContent || '');

            if (valores) {
                onUpdateValues?.(valores.numeroParcelas, valores.valorParcela, valores.valorTotal, valores.valorTotal - amount);
            } else {
                // fallback se não bater com o regex
                onUpdateValues?.(1, amount, amount, 0);
            }
        }, 1000);

        return () => clearInterval(interval); // cleanup
    }, [amount, onUpdateValues]);

    const callbacks = {
        onReady: () => {
            // Opcional: ocultar loading
        },
        onSubmit: ({ selectedPaymentMethod, formData }: any) => {
            return new Promise<void>((resolve, reject) => {
                fetch(`${apiUrl}/payments/process-payment/${paymentId}`, {
                    method: 'POST',
                    body: JSON.stringify(formData),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then(async (res) => {
                        const responseJson = await res.json();
                        if (!res.ok) {
                            return Promise.reject(responseJson.message || 'Ocorreu um erro desconhecido.');
                        }
                        return responseJson;
                    })
                    .then(data => {
                        onSubmit(data.id, data.status); // Chama o status brick
                    })
                    .catch(err => {
                        console.error('Erro:', err);
                        alertModal(err || 'Erro desconhecido');
                    });
            });
        },
        onError: (error: any) => console.error('Erro no PaymentBrick:', error),
    };

    return (
        <Payment
            initialization={initialization}
            customization={customization}
            onSubmit={callbacks.onSubmit}
            onReady={callbacks.onReady}
            onError={callbacks.onError}
        />
    );
}
